<template>
  <div class="manager_dashboard">
    <UserMenu></UserMenu>
    <div class="wrapper">
      <EnterprieSidebarMenu v-if="selectedComponent == 'PathwaysTab'" :show_menu="true" :show_back_button="false" back_link="managerReports"></EnterprieSidebarMenu>
      <nav id="sidebar1" v-if="selectedComponent != 'PathwaysTab'" 
        class="show_back_button"
      >
        <ul class="list-unstyled">
          <li class="" style="cursor: pointer;" @click="backtoPathway()">
            
              <img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />
              Back
            
          </li>
        </ul>
      </nav>
      


      <div class="content-wrapper"  style="padding-left: 165px;">
        <div class="container-wrapper center">
          <div class="my-3"></div>
          <div>
            <div style="width: 70%; float: left; text-align: left; ">
              <h3 class="d-inline heading text-uppercase">Pathways</h3>
            </div>
            <div style="clear: both;"></div>
          </div>
          <div class="border-bottom mt-1 mb-2"></div>

          <div class="col-12">
            <div class="tab-content" id="nav-tabContent">
              <component 
              :is="selectedComponent" 
              :ref="selectedComponent" 
              :pathwayId=pathwayId
              :accountId=accountId
              isPathwayTab=true>
              </component>
            </div>                
          </div>

        </div>



      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import UserMenu from '@/components/shared/user_menu.vue';
import EnterprieSidebarMenu from '@/components/shared/enterpriseadmin_sidebar_menu.vue';
import { checkIsManager, checkIsMentor } from '@/components/shared/utils.js';
import PathwaysTab from './enterpriseadmin_pathway_list_tab.vue';
import PathwayShowTab from './enterpriseadmin_showpathway.vue';
import PathwayStepTab from './enterpriseadmin_pathway_step.vue';


export default {
  components: {
    UserMenu,
    EnterprieSidebarMenu,
    PathwaysTab,
    PathwayStepTab,
    PathwayShowTab,
  },
  data() {
    return {
      selectedComponent: 'PathwaysTab',
      pathwayId: '',
      accountId: '',
    }
  },
  methods: {
    selectPathwayStepTab(pathwayId) {
      this.pathwayId = pathwayId;
      this.selectedComponent = 'PathwayStepTab';
    },
    showPathwayStepTab(pathwayId) {
      this.pathwayId = pathwayId;
      this.selectedComponent = 'PathwayShowTab';
    },
    backtoPathway() {
      this.selectedComponent = 'PathwaysTab';
    },
  },

  created() {
    this.accountId = this.$store.state.user_accountid;

  },
}
</script>

<style scoped>
select {
  height: 28px;
  padding: 0 0.5rem;
}
.rounded {
  border-radius: 10px !important;
}
.comp_chart_container {
  width: 99%;
}
.reps_chart_container {
  width: 99%;
}
@media (max-width: 1199.98px) {
  .comp_chart_container {
    width: 99%;
  }
  .reps_chart_container {
    width: 99%;
  }
}
@media (max-width: 1300px) {
  .report-panel-container {
    justify-content: left;
  }
}
@media (min-width: 1301px) {
  .report-panel-container {
    justify-content: center;
  }
}
.container-wrapper .heading {
    font-size: 24px !important;
    font-weight: normal !important;
}
.back_icon { width: 13px !important; }
#sidebar1 {
  min-width: 165px;
  max-width: 165px;
  background-color: #FFFFFF;
  min-height: 100vh;
  transition: opacity 2s linear;
  transform: translate(0);
  opacity: 1;
  padding-top: 120px;
  position: fixed;
}

@media (max-width: 1199.98px) {
  #sidebar1 {
    min-width: 145px;
    max-width: 145px;
  }
}
#sidebar1 ul li {
  padding: 0px 10px 0px 10px;
  display: block;
  color: #6c757d !important;
  margin-left: 5px;
}

.sidebar_view_mentee {
  min-width: 110px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/enterpriseadmin_pathway.vue